const Customers = {
  MKP: "1",
  FAMILHAO: "2",
  VIBE: "3",
  LIGA: "4",
  ACHOULEVOU: "6",
  VERO: "7",
  PLURIX: "8",
};
export default Customers;
